<template>
  <div class="item-tracker-container relative min-h-300 px-30 pb-30">
    <!-- <div class="title mb-20 text-center text-22 font-semibold">{{ $t('所属武器箱') }}</div> -->
    <div class="flex min-h-300">
      <div v-if="containerData && containerData.length > 0" class="left box-list w-485">
        <div
          v-for="container in containerData"
          :key="container.caseId"
          class="box-item relative flex h-94 cursor-pointer justify-between overflow-hidden rounded-l-[4px] px-15 py-10"
          :class="selectContainer === container.caseId ? 'bg-blue-50' : ''"
          @click="getContainerDetail(container.caseId)"
        >
          <div v-show="selectContainer === container.caseId" class="left-bar absolute left-0 top-0 h-full w-4 bg-blue"></div>
          <div class="flex items-center">
            <div class="item-img mr-10 h-74 w-109 rounded-[10px] bg-blue-50 px-7">
              <img :src="container.imageUrl" alt="" />
            </div>
            <div>
              <div class="mb-5 max-w-230 overflow-hidden text-ellipsis whitespace-nowrap text-14 text-black">{{ container?.caseName }}</div>
              <div class="mb-5 text-14 text-price">{{ monetaryUnit() }} {{ currencyTransform(container.price) }}</div>
              <div>{{ $t('上线时间') }}: {{ container.firstSaleDateFormat }}</div>
            </div>
          </div>
          <div v-if="container.itemId != 0 && container.itemId != ''" class="flex items-center">
            <a :href="`/cs2/${container.marketHashName}`" target="_blank">
              <span class="hover:text-primary hoverPrimary cursor-pointer text-gray">{{ $t('详情') }}>></span>
            </a>
          </div>
        </div>
      </div>

      <div v-if="itemsData" class="right item-list max-h-600 w-593 overflow-y-auto rounded-r-[4px] bg-blue-50">
        <div class="px-20 py-10">
          <div class="mb-20">{{ $t('此武器箱包含以下物品之一') }}</div>
          <template v-for="(item, index) in itemsData.unusualRarities" :key="index">
            <div>
              <div class="mb-10 bg-[#E1AC41] text-center text-white">{{ $t('特殊物品') }}</div>
              <div class="mb-10 flex cursor-pointer items-center justify-between" @click="item.showSpecial = !item.showSpecial">
                <div class="flex items-center pl-5">
                  <div class="item-img mr-10 h-74 w-109 rounded-[10px] bg-[#E9F0FC] px-7">
                    <img src="https://cdn.steamdt.com/detail/tracker-special.webp" alt="" />
                  </div>
                  <div>
                    <div class="text-black">{{ $t('一件极其罕见的特殊物品') }}</div>
                  </div>
                </div>
                <div>
                  <i v-if="!item.showSpecial" class="iconfont icon-xiangxiahuadong text-10"></i>
                  <i v-else class="iconfont icon-xiangxiahuadong rotate-180 transform text-10"></i>
                </div>
              </div>
              <div v-if="item.showSpecial" class="max-h-300 overflow-y-auto">
                <div class="special-item-list">
                  <a v-for="(subItem, index) in item.items" :key="index" target="_blank" :href="`/cs2/${subItem.marketHashName}`">
                    <div class="item flex items-center py-5 pl-20">
                      <div class="item-img mr-10 h-74 w-109 rounded-[10px] bg-[#E9F0FC] px-7">
                        <img :src="subItem.imageUrl" alt="" />
                      </div>
                      <div>
                        <div class="mb-10 text-black">{{ subItem?.name }}</div>
                        <div class="text-price">{{ monetaryUnit() }} {{ currencyTransform(subItem.minPrice) }} - {{ monetaryUnit() }}{{ currencyTransform(subItem.maxPrice) }}</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </template>

          <template v-for="(item, index) in itemsData.rarities" :key="index">
            <div>
              <div class="mb-10 text-center text-white" :style="{ backgroundColor: `${item.rarityColor}` }">{{ item?.rarityName }}</div>

              <div class="overflow-y-auto">
                <div class="special-item-list">
                  <a v-for="(subItem, index) in item.items" :key="index" target="_blank" :href="`/cs2/${subItem.marketHashName}`">
                    <div class="item flex items-center py-5 pl-5">
                      <div class="item-img mr-10 h-74 w-109 rounded-[10px] bg-[#E9F0FC] px-7">
                        <img :src="subItem.imageUrl" alt="" />
                      </div>
                      <div>
                        <div class="mb-10 text-black">{{ subItem?.name }}</div>
                        <div class="text-price">{{ monetaryUnit() }} {{ currencyTransform(subItem.minPrice) }} - {{ monetaryUnit() }}{{ currencyTransform(subItem.maxPrice) }}</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-else class="w-full py-50 text-center">
        <empty :empty-text="$t('暂无所属武器箱')"></empty>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import { containerList, containerDetail } from '~~/api/steam'
import empty from '~/components/common/empty.vue'
import { get } from '@vueuse/core'

const props = defineProps({
  dialogVisible: {
    type: Boolean,
    default: false
  },
  marketHashName: {
    type: String,
    default: ''
  },
  itemId: {
    type: String,
    default: ''
  }
})

const selectContainer = ref('')
const containerData = ref()
const itemsData = ref()

const getContainerDetail = async caseId => {
  const res = await containerDetail({ caseId, appId: 730 })
  selectContainer.value = caseId
  itemsData.value = res.data || []
}

const init = async () => {
  const containerRes = await containerList({ itemId: props.itemId })
  containerData.value = containerRes.data || []
  if (containerRes.data[0]?.caseId) {
    getContainerDetail(containerRes.data[0]?.caseId)
  }
}

onMounted(() => {
  init()
})
</script>

<style lang="scss">
.hoverPrimary {
  &:hover {
    color: #0252d9;
  }
}
.special-item-list {
  .item {
    &:hover {
      background-color: #dddfe7;
    }
  }
}
</style>
